class DcScrollReveal {
  constructor() {
    this.elements = document.querySelectorAll('[data-dc-reveal], [data-dc-section]');
    if (!this.elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      this.elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    this.observer = new IntersectionObserver(this.reveal, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    this.elements.forEach((element) => {
      element.classList.add('dc-reveal');
      this.observer.observe(element);
    });
  }

  reveal = (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      this.observer.unobserve(entry.target);
    });
  };
}

const initializeDcReveal = () => new DcScrollReveal();
document.addEventListener('DOMContentLoaded', initializeDcReveal);
document.addEventListener('shopify:section:load', initializeDcReveal);
